export function detectPartnerContext({hostname = '', pathname = '/', metaSlug = null, whiteLabel = false, routePartnerSlug = null, partnerDomain = 'procertcompliance.com'}) {
  const host = hostname.toLowerCase();
  const domain = partnerDomain.toLowerCase();
  const subdomain = host.endsWith(`.${domain}`) ? host.slice(0, -(domain.length + 1)) : null;
  const nativeSlug = subdomain && subdomain !== 'www' && !subdomain.includes('.') ? subdomain : null;
  const partnerSlug = nativeSlug || metaSlug || pathname.match(/^\/w\/([^/]+)/)?.[1] || routePartnerSlug || null;
  return {isWhiteLabel:!!partnerSlug || whiteLabel,partnerSlug};
}

export function getHeaderIdentity({isPartnerStore, partnerSlug, partner, branding = {}}) {
  if (!isPartnerStore) return {name:'ProCert Compliance',logo:'/assets/branding/procert-logo.png'};
  const currentPartner = partner && (!partnerSlug || partner.slug === partnerSlug) ? partner : null;
  const currentBrand = branding.isPartner && branding.partnerSlug === partnerSlug ? branding : null;
  return {
    name:currentPartner?.branding_settings?.store_name || currentPartner?.name || currentBrand?.name || 'Training store',
    logo:currentPartner?.branding_settings?.logo_url || currentBrand?.logoFull || null,
  };
}
